module.exports = __webpack_public_path__ + "img/Nut.230bab1e.svg";